import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deadline-modals',
  templateUrl: './deadline-modals.component.html',
  styleUrls: ['./deadline-modals.component.scss']
})
export class DeadlineModalsComponent implements OnInit {

  acceptanceDeadline: any = [];
  assignmentDeadline: any = [];

  constructor(private dialog: MatDialogRef<DeadlineModalsComponent>, @Inject(MAT_DIALOG_DATA) public parentData: any,
              private timeService: TimeService, private router: Router) { }

  ngOnInit() {
    console.log('par=-', this.parentData,this.parentData.type == 0);
    if (this.parentData.type == 0) {
      this.acceptanceDeadline = this.parentData.details || [];
    } else if (this.parentData.type == 1) {
      this.assignmentDeadline = this.parentData.details || [];
    }
  }

  closeModal(data= '') {
    this.dialog.close(data);
  }

  getDate(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }

  getDuration(value) {
    return (value) ? this.timeService.getDurationFromNow(value) : 'N/A';
  }

  openDashboard(ev: Event, mode, type) {
    this.closeModal();
    this.router.navigateByUrl(`dashboard/${mode}/${type}`);
    ev.stopPropagation();
  }

}
